<template>
  <div class="choose-question">
    <el-dialog
      class="question_Dialog"
      :visible.sync="show"
      width="900px"
      :modal="false"
      :before-close="handleClose"
    >
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        class="form-inline"
        size="small"
      >
        <el-form-item label="题目名称" prop="query">
          <el-input
            v-model="searchForm.query"
            placeholder="题目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="题型" prop="type">
          <el-select
            v-model="searchForm.type"
            placeholder="请选择"
            style="width: 140px"
          >
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.label"
              :value="item.type"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="章节" prop="chapterId">
          <el-cascader
            v-model="searchForm.chapterId"
            :options="chapters"
            :props="{
              label: 'title',
              value: 'chapterId',
              emitPath: false,
            }"
            :show-all-levels="false"
            placeholder="请选择章节"
            clearable
          ></el-cascader>
          <!-- <el-select v-model="searchForm.chapterId" placeholder="请选择章节">
            <el-option label="全部" :value="null"></el-option>
            <el-option-group
              v-for="group in chapters"
              :key="group.chapterId"
              :label="group.title"
            >
              <el-option
                v-for="item in group.children"
                :key="item.chapterId"
                :label="item.title"
                :value="item.chapterId"
              >
              </el-option>
            </el-option-group>
          </el-select> -->
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getList"
          ></el-button>
          <el-button
            icon="el-icon-refresh"
            @click="resetForm('searchForm')"
          ></el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        stripe
        style="width: 100%"
        class="question-bank"
        highlight-current-row
        ref="table"
        max-height="341"
        @select="handleSelect"
        @select-all="handleSelect"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="question" label="题目名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="type"
          label="题型"
          :formatter="typeFormatter"
          width="100"
          align="center"
        >
        </el-table-column>
      </el-table>
      <div slot="footer">
        <div class="foot_page">
          <el-pagination
            background
            layout="prev, pager, next, jumper"
            :page-size="searchForm.limit"
            :current-page.sync="searchForm.page"
            :total="total"
            @current-change="getList"
          ></el-pagination>
        </div>
        <el-button type="primary" class="save_btn" @click="confirm" size="small"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkType, handleTree } from "@/utils/index";
import { questionList, questionInfo } from "@/api/questionBank";
import { chapterList } from "@/api/chapter";
export default {
  props: {
    // 控制弹窗显现
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkType,
      list: [],
      searchForm: {
        page: 1,
        limit: 5,
        query: "",
        courseId: null,
        chapterId: null,
        type: null,
      },
      total: 0,
      typeList: [
        { label: "全部", type: null },
        { label: "单选题", type: "RADIO" },
        { label: "多选题", type: "CHECKBOX" },
        { label: "判断题", type: "BOOLEAN" },
        { label: "填空题", type: "SUPPLY" },
        { label: "简答题", type: "ANSWER" },
      ],
      chapters: [],
      obj: {},
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.getList();
        this.getChapterList();
      }
    },
    list(val) {
      this.$nextTick(() => {
        (this.obj[this.searchForm.page] || []).forEach((item) => {
          this.$refs.table.toggleRowSelection(
            val.find((n) => n.questionId === item.questionId)
          );
        });
      });
    },
  },
  methods: {
    // 章节列表
    getChapterList() {
      chapterList({ classId: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          //   console.log(res);
          this.chapters = handleTree(res.data, "chapterId");
        } else {
          console.log(res.msg);
        }
      });
    },
    getList() {
      this.searchForm.courseId = this.$route.query.courseId;
      this.$loading.show();
      questionList(this.searchForm).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 关闭
    handleClose() {
      this.obj = {};
      this.searchForm = this.$options.data().searchForm;
      this.$emit("closeChoose");
    },
    typeFormatter(row) {
      return checkType(row.type);
    },
    // 选择题目
    handleSelect(selection) {
      this.obj[this.searchForm.page] = [...selection];
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getList();
    },
    confirm() {
      if (JSON.stringify(this.obj) == "{}") {
        this.$message.warning("请至少选中一题");
        return;
      }

      let ids = [];
      for (let idx in this.obj) {
        this.obj[idx].forEach((item) => {
          ids.push(item.questionId);
        });
      }
      this.$loading.show();
      questionInfo(ids).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$emit("addQuestion", res.data);
          this.handleClose();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.choose-question {
  text-align: left;
  ::v-deep  .question-bank {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .foot_page {
    float: left;
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #0d79ff;
    }
  }
}
</style>